import { Link } from "react-router-dom";
import { brand } from "@mbb/config";
import Crest from "./Crest";
import { useAuth } from "../lib/auth";

export default function Footer() {
  const { user } = useAuth();
  const year = new Date().getFullYear();
  const signedIn = Boolean(user);

  return (
    <footer
      style={{
        background: "var(--c-palm)",
        color: "var(--c-sand)",
        paddingBlock: signedIn ? "2.25rem" : "4rem",
      }}
    >
      <div
        className="container"
        style={{
          display: "grid",
          gap: signedIn ? "1.25rem" : "2.5rem",
          gridTemplateColumns: "1fr",
          textAlign: "center",
        }}
      >
        {!signedIn && (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <Crest size={72} />
              <div
                className="display"
                style={{
                  fontSize: "clamp(2rem, 5vw, 3rem)",
                  color: "var(--c-sand)",
                  fontStyle: "italic",
                }}
              >
                ready to join us?
              </div>
              <p className="lead" style={{ maxWidth: "44ch", opacity: 0.9 }}>
                {brand.tagline} One book a month, no pressure, real friendships.
              </p>
              <Link
                to="/apply"
                className="btn btn--on-palm"
                style={{ marginTop: "0.5rem" }}
              >
                Apply now
              </Link>
            </div>
            <hr className="rule" style={{ background: "rgba(251, 242, 230, 0.25)" }} />
          </>
        )}
        <div
          className="eyebrow"
          style={{ color: "var(--c-blush)", fontSize: "0.7rem", letterSpacing: "0.3em" }}
        >
          © {year} {brand.name} · est. {brand.established} · Manteca, CA
        </div>
      </div>
    </footer>
  );
}
